<script>
import Drawer from "@/components/drawer";

// Custom Components
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";

// Booking Sync History
export default {
  page: {
    title: "Sync History",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Sync History",
      table: {
        tableData: [],
        size: 100,
        next: null,
        previous: null,
      },
      failedOperation: [],
      isDataLoading: false,
      isDrawerOpen: false,
    };
  },
  components: {
    PageHeader,
    Drawer,
  },
  mounted() {
    this.getSyncRecords("?size=" + this.table.size);
  },
  methods: {
    // Method is used for get sync records
    async getSyncRecords(query, status) {
      try {
        this.isDataLoading = true;
        const response = await UserService.getPMSSyncRecord(query);
        if (response !== null) {
          this.table.tableData = [...this.table.tableData, ...response.results];
          this.table.previous = response.previous;
          this.table.next = response.next;
          this.isDataLoading = false;
          if (status == "load_more") {
            setTimeout(() => {
              this.$refs.scrollTo.click();
            }, 500);
          }
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to get more guest
    loadMore: function () {
      if (this.table.next !== null) {
        const str = this.table.next.split("?");
        this.getSyncRecords(`?${str[1]}`, "load_more");
      }
    },
    // Method is used to open failed operation drawer
    viewFailedOperation(data) {
      if (data) {
        this.failedOperation = data;
      }
      this.isDrawerOpen = !this.isDrawerOpen;
    },
  },
};
</script>
<template>
  <div>
    <PageHeader :title="title" />
    <div
      class="row"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="isDataLoading"
      infinite-scroll-distance="100"
    >
      <a
        href="#"
        v-scroll-to="{
          element: `#sync${table.tableData.length - 1}`,
          offset: 500,
        }"
        ref="scrollTo"
        class="d-none"
        >Scroll</a
      >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <v-table
                    :data="table.tableData"
                    class="table table-hover mb-0"
                    ref="my-table"
                  >
                    <thead class="table-light" slot="head">
                      <tr>
                        <v-th sortKey="operation_type"> Operation Type </v-th>
                        <v-th sortKey="created_at">Date</v-th>
                        <th>Create By</th>
                        <th>Operation Result</th>
                      </tr>
                    </thead>
                    <tbody v-if="isDataLoading && table.tableData.length < 100">
                      <tr v-for="item in 13" :key="item">
                        <td class="placeholder-glow" v-for="no in 4" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody
                      class="infinite-list"
                      slot="body"
                      slot-scope="{ displayData }"
                      v-if="table.tableData.length > 0 && !isDataLoading"
                    >
                      <tr
                        v-for="(data, index) in displayData"
                        :key="index"
                        :id="'sync' + index"
                      >
                        <td class="text-capitalize">
                          {{ data.operation_type }}
                        </td>
                        <td>
                          {{ global_format_date_and_time(data.created_at) }}
                        </td>
                        <td>{{ data.created_by }}</td>
                        <td
                          v-if="data.failed_pms_operation.length !== 0"
                          @click="
                            viewFailedOperation(data.failed_pms_operation)
                          "
                        >
                          <i class="fas fa-tasks text-primary"></i>
                        </td>
                        <td v-else>
                          <span
                            class="badge card-badge badge-soft-success font-size-12"
                            >Success</span
                          >
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isDataLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Drawer is used to show sync errors -->
    <Drawer
      @close="viewFailedOperation"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="isDrawerOpen">
        <div class="table-responsive mb-0">
          <table class="table table-hover mb-0">
            <thead class="table-light" slot="head">
              <tr>
                <th>Error Line</th>
                <th>Message</th>
              </tr>
            </thead>

            <tbody class="infinite-list" v-if="failedOperation.length > 0">
              <tr v-for="(data, index) in failedOperation" :key="index">
                <td>
                  {{ data.error_line }}
                </td>
                <td>
                  {{ data.message }}
                </td>
              </tr>
            </tbody>
            <tbody v-if="failedOperation.length == 0">
              <tr>
                <td colspan="9" class="text-center">
                  <img
                    src="@/assets/images/empty.svg"
                    class="img-fluid"
                    alt=""
                  />
                  <p>
                    <span class="text-secondary">No Data Found</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Drawer>
  </div>
</template>
<style></style>
